// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1qG1m","label":"SetPasswdForm_label__2AfXZ"};